var _style, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpencars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 435 417",
    style: {
      enableBackground: "new 0 0 435 417"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{display:none;fill:#010201;}\n\t.st3{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.4,787.1c76.8,0,119.5,0,147.4-27.9c27.9-27.9,27.9-70.6,27.9-147.4s0-119.5-27.9-147.4 c-27.9-27.9-70.6-27.9-147.4-27.9s-119.5,0-147.4,27.9C35,492.2,35,534.9,35,611.7s0,119.5,27.9,147.4 C90.8,787.1,133.5,787.1,210.4,787.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.0495,
    y1: 389.4625,
    x2: 212.0495,
    y2: 35.4368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#44AD5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B76BB"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212,389.5c-99.1,0-125.8-5-148.9-28.1C39.9,338.1,35,311.6,35,212.4s5-125.7,28.1-148.9 C86.2,40.5,112.9,35.4,212,35.4s125.8,5,148.9,28.1c23.2,23.2,28.1,49.8,28.1,148.9s-4.9,125.7-28.1,148.9 C337.9,384.4,311.2,389.5,212,389.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M593.4,787.1c76.8,0,119.5,0,147.4-27.9c27.9-27.9,27.9-70.6,27.9-147.4s0-119.5-27.9-147.4 c-27.9-27.9-70.6-27.9-147.4-27.9s-119.5,0-147.4,27.9C418,492.2,418,534.9,418,611.7s0,119.5,27.9,147.4 C473.8,787.1,516.5,787.1,593.4,787.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M324.5,175.7l4-4.1c3-3,3.7-7.7,1.5-11.4c-3.2-5.2-10.1-5.8-14.1-1.7l-4.2,4.3l-8.1-33.1 c-2.9-11.9-14.6-21.2-26.6-21.2H147.3c-12,0-23.7,9.3-26.6,21.2l-8.1,33.1l-4.2-4.3c-4-4.1-10.9-3.5-14.1,1.7 c-2.2,3.6-1.5,8.3,1.5,11.4l4,4.1c-13.1,6.6-22.2,20.3-22.2,36.2v32.2c0,13,6.1,24.6,15.5,31.9v16.1c0,13.2,10.7,23.8,23.8,23.8 H143c8.5,0,15.5-6.9,15.5-15.5v-15.5h107.3v15.5c0,8.5,6.9,15.5,15.5,15.5h26.2c13.2,0,23.8-10.7,23.8-23.8v-16.1 c9.4-7.4,15.5-19,15.5-31.9V212C346.8,196.1,337.7,182.3,324.5,175.7z M130.4,169.4L139,135c0.9-3.7,5.5-7.3,9.3-7.3h127.9 c3.8,0,8.4,3.5,9.3,7.3l8.6,34.5c0.2,1,0.2,1.8-0.1,2.2c-0.3,0.4-1.1,0.7-2.1,0.7H132.6c-1,0-1.8-0.2-2.1-0.7 C130.2,171.2,130.2,170.4,130.4,169.4z M117.7,190.5h189.8c12.1,0,22,9.8,22,22v32.5c0,12.1-9.8,22-22,22H117.7 c-12.1,0-22-9.8-22-22v-32.5C95.7,200.3,105.5,190.5,117.7,190.5z M140.3,292.4c0,3-2.5,5.5-5.5,5.5h-18.2c-3,0-5.5-2.5-5.5-5.5 v-7.7c2,0.3,4.1,0.5,6.3,0.5h22.8L140.3,292.4L140.3,292.4z M313.1,292.4c0,3-2.5,5.5-5.5,5.5h-18.2c-3,0-5.5-2.5-5.5-5.5v-7.2 h22.8c2.1,0,4.2-0.2,6.3-0.5L313.1,292.4L313.1,292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M181,237.8h62.2c4.9,0,9.1-3.7,9.4-8.5c0.3-5.3-3.9-9.7-9.1-9.7h-62.2c-4.9,0-9.1,3.7-9.4,8.5 C171.6,233.4,175.8,237.8,181,237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.6,253.4c13.7,0,24.9-11.2,24.9-24.9c0-13.7-11.2-24.9-24.9-24.9c-13.7,0-24.9,11.2-24.9,24.9 C108.7,242.2,119.8,253.4,133.6,253.4z M133.6,221.9c3.6,0,6.6,3,6.6,6.6c0,3.6-3,6.6-6.6,6.6c-3.6,0-6.6-3-6.6-6.6 C127,224.8,129.9,221.9,133.6,221.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291,253.4c13.7,0,24.9-11.2,24.9-24.9c0-13.7-11.2-24.9-24.9-24.9s-24.9,11.2-24.9,24.9 C266.1,242.2,277.2,253.4,291,253.4z M291,221.9c3.6,0,6.6,3,6.6,6.6c0,3.6-3,6.6-6.6,6.6c-3.6,0-6.6-3-6.6-6.6 C284.4,224.8,287.3,221.9,291,221.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpencars);
export default __webpack_public_path__ + "static/media/opencars.efb447e5db50729bd21751117e736d48.svg";
export { ForwardRef as ReactComponent };